import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoriaService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar categorias
  list(params?: any): Observable<any> {
    return this.apiService.get(`/Categoria`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  listPublic(params?: any): Observable<any> {
    return this.apiService.get(`/Categoria/Dominio`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria uma nova categoria
* @param categoria
* @returns Observable<any>
*/
  public store(categoria: any): Observable<any> {
    return this.apiService.post(`/Categoria`, categoria);
  }

  // atualizar categoria
  update(categoria: any): Observable<any> {
    return this.apiService.put(`/Categoria`, categoria);
  }

  toggleStatus(id: string): Observable<any> {
    return this.apiService.patch(`/Categoria/${id}`);
  }
}
